import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from "@mui/material"

export default function FileImageModal({
    header,
    url,
    open,
    closeModal,
}) {
    return (
        <div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                maxWidth={'xl'}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>{header}</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <center>
                        <Box component="img" alt={"Image"} src={url} sx={{ maxHeight: '100%', maxWidth: '100%'}} />
                    </center>
                </DialogContent>
            </Dialog>
        </div>
    )
}
